"use client";

import React from "react";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface GenderSelectionProps {
  petName: string;
  selectedGender: "male" | "female" | null;
  setSelectedGender: (gender: "male" | "female" | null) => void;
  error: string;
  isLoading: boolean;
  groupRef: React.RefObject<HTMLDivElement>;
}

const GenderSelection: React.FC<GenderSelectionProps> = ({
  petName,
  selectedGender,
  setSelectedGender,
  error,
  isLoading,
  groupRef,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2 field-row" ref={groupRef}>
      <Label htmlFor="gender">{petName ? t("petDetails.gender", { petName: petName}) : t("petDetails.genderUndefined") }</Label>
      <div className="flex gap-2">
        <Button
          variant={selectedGender === "male" ? "default" : "outline"}
          onClick={() => setSelectedGender("male")}
          className={cn(
            "flex-1",
            selectedGender === "male" && "bg-primary text-primary-foreground"
          )}
          disabled={isLoading}
        >
          {t("petDetails.genderMale")}
        </Button>
        <Button
          variant={selectedGender === "female" ? "default" : "outline"}
          onClick={() => setSelectedGender("female")}
          className={cn(
            "flex-1",
            selectedGender === "female" && "bg-primary text-primary-foreground"
          )}
          disabled={isLoading}
        >
          {t("petDetails.genderFemale")}
        </Button>
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};

export default GenderSelection;
